import React from "react"
import PageTemplate from "../../../templates/pageTemplate.jsx"
import ArticleTemplate from "../../../templates/articleTemplate.jsx"
import PrestationTemplate from "../../../templates/prestationTemplate.jsx"
import NewsTemplate from "../../../templates/newsTemplate.jsx"
import PharmacyTemplate from "../../../templates/pharmacyTemplate.jsx"
import JobTemplate from "../../../templates/jobTemplate.jsx"
import FormationTemplate from "../../../templates/formationTemplate.jsx"
import EventTemplate from "../../../templates/eventTemplate.jsx"
import {
  resolveCollectionTree,
  fetchStatamicResource,
} from "gatsby-source-statamic"
import axios from "axios"

const PagePreviewTemplate = ({ params, location }) => {
  const [isLoading, setIsLoading] = React.useState(true)
  const [data, setData] = React.useState(null)
  const [isSuccess, setIsSuccess] = React.useState(false)

  React.useEffect(() => {
    const getPreviewData = async () => {
      try {
        const response = await axios.get(
          `/api/collections/${params.type}/entries/${params.id}${location.search}`,
          {
            headers: {
              "X-Statamic-Live-Preview": true,
            },
          }
        )

        let categories = null,
          prestations = null,
          events = null,
          formations = null,
          pharmacies = null,
          form = null

        const tree = await fetchStatamicResource(
          `api/collections/pages/tree?limit=9999999`
        )

        const allPages = await fetchStatamicResource(
          `api/collections/pages/entries?limit=9999999&fields=id,slug,title,headers,mount`
        )

        if (params.type === "jobs") {
          form = await fetchStatamicResource(`api/globals/jobApplicationForm`)
        }

        if (params.type === "prestations") {
          prestations = {
            nodes: await fetchStatamicResource(
              `api/collections/prestations/entries?limit=9999999&fields=id,uri,title,teaserExcerpt,teaserImage`
            ),
          }
          pharmacies = {
            nodes: await fetchStatamicResource(
              `api/collections/pharmacies/entries?limit=9999999&fields=id,title,slug,street,zipCode,city,state,latitude,longitude,prestations`
            ),
          }
        }

        if (params.type === "events") {
          events = {
            nodes: await fetchStatamicResource(
              `api/collections/events/entries?limit=9999999&fields=id,uri,title,teaserExcerpt,teaserImage,startDate,startTime,endDate,endTime`
            ),
          }
          pharmacies = {
            nodes: await fetchStatamicResource(
              `api/collections/pharmacies/entries?limit=9999999&fields=id,title,slug,street,zipCode,city,state,latitude,longitude,events`
            ),
          }
        }

        if (params.type === "formations") {
          formations = {
            nodes: await fetchStatamicResource(
              `api/collections/formations/entries?limit=9999999&fields=id,uri,title,teaserExcerpt,teaserImage`
            ),
          }
          pharmacies = {
            nodes: await fetchStatamicResource(
              `api/collections/pharmacies/entries?limit=9999999&fields=id,title,slug,street,zipCode,city,state,latitude,longitude,formations`
            ),
          }
        }

        if (params.type === "articles") {
          categories = {
            nodes: await fetchStatamicResource(
              `api/taxonomies/category/terms?limit=9999999&fields=title,slug`
            ),
          }
        }

        const mountRef = allPages.find(
          page => page?.mount?.handle === params.type
        )
        let mount = null
        if (mountRef) {
          mount = await fetchStatamicResource(
            `api/collections/pages/entries/${mountRef.id}?fields=id,slug,title,headers`
          )
        }

        const resolvedTree = resolveCollectionTree(tree)

        let sidemenu = null
        if (resolvedTree[response.data.data.id]?.siblings) {
          sidemenu = {
            nodes: allPages.filter(page =>
              resolvedTree[response.data.data.id].siblings.includes(page.id)
            ),
          }
        }

        let parents = null
        if (resolvedTree[response.data.data.id]?.parents) {
          parents = {
            nodes: allPages.filter(page =>
              resolvedTree[response.data.data.id].parents.includes(page.id)
            ),
          }
        }

        /**
         * we need to fetch relations
         */
        if (response.data?.data?.content) {
          for (let i = 0; i < response.data.data?.content.length; i++) {
            if (response.data.data.content[i].type === "magazines") {
              response.data.data.content[i].magazine =
                await fetchStatamicResource(
                  response.data.data.content[i].magazine.api_url
                )
            }
          }
        }

        const data = {
          ...response.data.data,
          header: response.data.data?.header?.map(content => ({
            ...content,
            __typename:
              content.type.charAt(0).toUpperCase() + content.type.slice(1),
          })),
          content: response.data.data?.content?.map(content => ({
            ...content,
            __typename:
              content.type.charAt(0).toUpperCase() + content.type.slice(1),
          })),
          footer: response.data.data?.footer?.map(content => ({
            ...content,
            __typename:
              content.type.charAt(0).toUpperCase() + content.type.slice(1),
          })),
        }

        setData({
          data: {
            [`collection${
              params.type.charAt(0).toUpperCase() + params.type.slice(1)
            }`]: data,
            sidemenu,
            parents,
            mount,
            categories,
            prestations,
            pharmacies,
            formations,
            events,
            form,
          },
          pageContext: {
            preview: true,
            locale: data.locale,
            translations: [],
          },
        })
        setIsLoading(false)
        setIsSuccess(true)
      } catch (error) {
        console.log(error)
        setIsLoading(false)
        setIsSuccess(false)
      }
    }
    getPreviewData()
  }, [])

  if (isLoading) {
    return "...chargement"
  }

  if (!isSuccess) {
    return (
      <div style={{ padding: "10px" }}>
        Erreur de chargement. Voici ce qui cause habituellement ce problème:
        <ul>
          <li>La page n'est pas publiée</li>
          <li>La page n'a pas encore été enregistrée</li>
        </ul>
        Si tout ceci est en ordre, vous pouvez faire une demande de support en
        indiquant les informations suivantes:
        <blockquote>
          type de contenu: {params.type}
          <br />
          identifiant:{params.id}
        </blockquote>
      </div>
    )
  }

  switch (params.type) {
    case "articles":
      return (
        <ArticleTemplate
          data={data.data}
          pageContext={data.pageContext}
          location={{ href: "#" }}
        />
      )
    case "pages":
      return (
        <PageTemplate
          data={data.data}
          pageContext={data.pageContext}
          location={{ href: "#" }}
        />
      )
    case "pharmacies":
      return (
        <PharmacyTemplate
          data={data.data}
          pageContext={data.pageContext}
          location={{ href: "#" }}
        />
      )
    case "news":
      return (
        <NewsTemplate
          data={data.data}
          pageContext={data.pageContext}
          location={{ href: "#" }}
        />
      )
    case "jobs":
      return (
        <JobTemplate
          data={data.data}
          pageContext={data.pageContext}
          location={{ href: "#" }}
        />
      )
    case "prestations":
      return (
        <PrestationTemplate
          data={data.data}
          pageContext={data.pageContext}
          location={{ href: "#" }}
        />
      )
    case "formations":
      return (
        <FormationTemplate
          data={data.data}
          pageContext={data.pageContext}
          location={{ href: "#" }}
        />
      )
    case "events":
      return (
        <EventTemplate
          data={data.data}
          pageContext={data.pageContext}
          location={{ href: "#" }}
        />
      )
    default:
      return "Il n'y a pas de prévisualition pour cette collection."
  }
}

export default PagePreviewTemplate
